/* import __COLOCATED_TEMPLATE__ from './phone-section.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsContactInfoPhoneSection extends Component {
  get phoneIsRequired() {
    if (this.demographicsForm.isCouple) return this.#couplePhoneRequirements;

    if (this.phoneNumberAttr === 'phoneNumber') return this.#primaryPhoneRequirements;

    return this.demographicsForm.isRequiredEmergencyContactPhoneNumber;
  }

  get #couplePhoneRequirements() {
    return (
      this.demographicsForm.isRequiredPhoneNumber ||
      this.demographicsForm.isRequiredEmergencyContactPhoneNumber
    );
  }

  get #primaryPhoneRequirements() {
    if (this.demographicsForm.isMinor) return false;

    return this.demographicsForm.isRequiredPhoneNumber;
  }
}
